import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { UnlockProvider } from './components/state'
import { AuthProvider } from './contexts/AuthContext'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AuthProvider>
      <UnlockProvider>
        <App />
      </UnlockProvider>
    </AuthProvider>
  </React.StrictMode>,
)


